var _rect, _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeletesvg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 34,
    viewBox: "0 0 41 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 34,
    rx: 5,
    fill: "url(#paint0_linear_1004_2398)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3248 14.4682C28.3248 14.4682 27.7818 21.2032 27.4668 24.0402C27.3168 25.3952 26.4798 26.1892 25.1088 26.2142C22.4998 26.2612 19.8878 26.2642 17.2798 26.2092C15.9608 26.1822 15.1378 25.3782 14.9908 24.0472C14.6738 21.1852 14.1338 14.4682 14.1338 14.4682",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.708 11.2397H12.75",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4406 11.2397C25.6556 11.2397 24.9796 10.6847 24.8256 9.9157L24.5826 8.6997C24.4326 8.1387 23.9246 7.7507 23.3456 7.7507H19.1126C18.5336 7.7507 18.0256 8.1387 17.8756 8.6997L17.6326 9.9157C17.4786 10.6847 16.8026 11.2397 16.0176 11.2397",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1004_2398",
    x1: 26.5294,
    y1: 10.9286,
    x2: -18.132,
    y2: 33.7417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0000",
    stopOpacity: 0.08
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletesvg);
export default __webpack_public_path__ + "static/media/deletesvg.eb8dcd73ccfaa2160edc636997d5b5c3.svg";
export { ForwardRef as ReactComponent };